import {
  Button,
  FormRow,
  Input,
  Modal,
  Spacer,
  Spinner,
  Stack,
  Text
} from '@efast_public/fjd-component-library';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';

import { UpdateOrgUnitModel } from '../api/hooks/useOrganization';
import { useNotification } from '../shared/notification/useNotification';
import { BehApiRoutes, behClient } from '../api/beh-api';
import { useMutation } from '@tanstack/react-query';

interface RenameOrgUnitModalProps {
  readonly onClose: () => void;
  readonly onSuccess: () => void;
  readonly defaultOrgUnitName: string;
  readonly orgUnitId: string;
}

export function RenameOrgUnitModal({
  onClose,
  onSuccess,
  defaultOrgUnitName,
  orgUnitId
}: RenameOrgUnitModalProps) {
  const { notifyUserFromRequest } = useNotification();
  const { t } = useTranslation();
  const [orgUnitName, setOrgUnitName] = useState<string>(defaultOrgUnitName);

  const { mutateAsync: updateOrgUnit, isPending: isLoading } = useMutation({
    mutationFn: ({ orgUnit }: UpdateOrgUnitModel) =>
      notifyUserFromRequest(() =>
        behClient.put(BehApiRoutes.orgUnitById(orgUnitId), orgUnit)
      )
  });

  return (
    <Modal open onClose={onClose}>
      <Modal.Header id="RenameOrgUnitModal-header">
        {t('renameDestinationModal.title')}
      </Modal.Header>

      <Modal.Content>
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <Stack spacing="xs">
            <div>
              <Text size="s" strong>
                {t('renameDestinationModal.contentHeading')}
              </Text>
            </div>
            <Text size="s">{t('renameDestinationModal.content')}</Text>
            <Spacer size="m" />
            <FormRow
              label={defaultOrgUnitName}
              id={`label${defaultOrgUnitName}`}
            >
              <Input
                id={`input_${defaultOrgUnitName}`}
                type="text"
                min={0}
                onBlur={(event) => {
                  setOrgUnitName(event.target.value);
                }}
                defaultValue={defaultOrgUnitName}
              />
            </FormRow>
          </Stack>
        </form>
      </Modal.Content>
      <Modal.Footer direction="rtl" alignment="none">
        <Button size="sm" variant="primary-text" onClick={onClose}>
          {t('globalNotifications.modalAboard')}
        </Button>
        <Button
          size="sm"
          variant="primary"
          disabled={isLoading}
          onClick={() => {
            updateOrgUnit({
              orgUnit: { name: orgUnitName }
            }).then(() => {
              onSuccess();
            });
          }}
        >
          {isLoading ? <Spinner /> : t('globalNotifications.modalSave')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
